import React, {useState, useEffect} from 'react'
import TextField from '@material-ui/core/TextField';

/*
const useStyles = createTheme((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));*/

export default function TextFields_Outlined({id, label, triggerUpdateInParent, validationText, required, noSpaces, extraClasses, valueInField, classesToAdd}) {
  //const classes = useStyles();
  const [requiredError, setRequiredError] = useState(false);
  const [helperText, setHelperText] = useState('');

  // This will turn the help text on when something such as a validation
  // fails in the parent component
  useEffect(() => {
    setHelperText(validationText)
  }, [validationText]);

  const handleChange = (event) => {
    //if (noSpaces) event.target.value = event.target.value.toString().trim();
    if (noSpaces) event.target.value = event.target.value.toString().replace(/ /g,'');
    triggerUpdateInParent(id, event.target.value)
    if (required && event.target.value == ""){
      setRequiredError(true)
      setHelperText('Required field.')
    }
    else if (validationText == ""){
      setRequiredError(false)
      setHelperText('')
    }

    // Check to see if the validation failed in the parent component and
    // wants to pass some text into here
    //setHelperText(validationText)
    //console.log("FAILED VALIDATIONT TEXT: "+ validationText)
  };
//{/*style={{ margin: 8 }} removed from TextField*/}
  return (
    <div style={{marginTop: '5px', marginBottom: '5px'}}>
      {required ? <span className="required-field">*</span> : <span className="unrequired-field">*</span>}
      <TextField defaultValue={valueInField} className={extraClasses+" "+classesToAdd} id={id} label={label}  variant="outlined" helperText={helperText} onFocusOut={() => setRequiredError(true)} onChange={handleChange}
      error={requiredError}
      />
    </div>
  );
  {/*<form className={classes.root} noValidate autoComplete="off">*/}
  {/*</form>*/}
}